// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import wixData from 'wix-data';

$w.onReady(function () {
	//TODO: write your page related code here...
});

export function generateVoucherButton_click(event) {
// Create voucher ID
    let voucherID = Math.random()*25131232513;
    voucherID = Math.floor(voucherID);
    //voucherID = voucherID.toString();
    //console.log(voucherID.type);

// Create voucher expiration date - today + 90 days
    let dateNow = new Date();
    dateNow.setDate(dateNow.getDate() + 90);
    let voucherExpirationDate = dateNow;

// Activate voucher
    let voucherStatus = true;
// Input data from text boxes saved in array 
    let toSave = {
      "Customer Name": $w('#customerNameInput').value,
      "Voucher From": $w('#voucherFromInput').value,
      "Package Description": $w('#packageDescriptionInput').value,
      "Voucher ID": voucherID.toString(),
      "Expiration Date": voucherExpirationDate,
      "Voucher Status": voucherStatus,
      "Voucher Value": "₪"+$w('#voucherValue').value
    };

//Save input data to DB
    wixData.save("Vouchers", toSave);
}
/*
export function voucherDropdown_change(event) {
	//Add your code for this event here: 
    //console.log($w('#voucherDropdown').value);
    let packageDescription = wixData.get("Vouchers", "45");
    //let packageDescription = wixData.query("Vouchers").find('45');
    console.log(packageDescription);
    console.log($w("#dataset1").getCurrentItem());

} */